import { jsx, jsxs } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { c as classNames, l as liveAnnounce, L as Level } from '../index_orig/index-chunk.esm.js';
import styles from '../styles/uitk-egds-loader.css';
const getClassNameList$2 = classNames.bind(styles);
const Loader = props => {
  const {
    className,
    isDarkBackground,
    isSmall,
    entryAnimation = false,
    l10n,
    title,
    ...attributes
  } = props;
  const loaderTitle = title || l10n.formatText('loading');
  const baseClassName = 'uitk-loader';
  const cssClassNames = getClassNameList$2(baseClassName, className, {
    [`${baseClassName}-dark`]: isDarkBackground,
    [`${baseClassName}-small`]: isSmall,
    [`${baseClassName}-animate`]: entryAnimation
  });
  return jsx("span", {
    className: cssClassNames,
    title: loaderTitle,
    ...attributes,
    children: jsx("span", {
      className: "is-visually-hidden",
      children: loaderTitle
    })
  });
};
const EGDSLoader = props => {
  const l10n = useLocalization();
  return jsx(Loader, {
    l10n: l10n,
    ...props
  });
};
EGDSLoader.displayName = 'EGDSLoader';
const getClassNameList$1 = classNames.bind(styles);
const LoaderContainer = props => {
  const {
    children,
    className,
    isDarkBackground,
    isSmall,
    pageIsLoaded = false,
    l10n,
    title,
    ...attributes
  } = props;
  const loaderTitle = title || l10n.formatText('loading');
  const baseClassName = 'uitk-loader';
  const cssClassNames = getClassNameList$1(baseClassName, className, {
    [`${baseClassName}-dark`]: isDarkBackground,
    [`${baseClassName}-small`]: isSmall,
    [`${baseClassName}-page-spinner`]: true
  });
  const loaderContainerClass = getClassNameList$1('uitk-loader-container');
  const loaderWrapperClass = getClassNameList$1('uitk-loader-wrapper');
  const loaderContentClass = getClassNameList$1('uitk-loader-content');
  const loaderRef = React.useRef(null);
  const wrapperRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const loadingTransformAnimation = {
    transform: 'translateY(-64px)'
  };
  const loadingOpacityAnimation = {
    opacity: [1, 0]
  };
  const contentAnimation = [
  // Keyframes
  {
    transform: 'translateY(64px)',
    opacity: 0
  }, {
    transform: 'translateY(0px)',
    opacity: 1
  }];
  const transformTime = {
    duration: 300,
    iterations: 1,
    easing: 'cubic-bezier(0.5, 0, 0, 1)'
  };
  const opacityTime = {
    duration: 300,
    iterations: 1,
    easing: 'cubic-bezier(0.5, 0, 0.5, 1)'
  };
  const contentTime = {
    duration: 300,
    iterations: 1
  };
  // Remove all animations when page is marked as loaded
  React.useEffect(() => {
    const currLoader = loaderRef.current;
    const currContent = contentRef.current;
    const currWrapper = wrapperRef.current;
    if (pageIsLoaded && currLoader && currContent) {
      currLoader.animate(loadingTransformAnimation, transformTime);
      currLoader.animate(loadingOpacityAnimation, opacityTime);
      currContent.animate(contentAnimation, contentTime);
      Promise.all(currLoader.getAnimations().map(animation => animation.finished)).then(() => currWrapper?.classList.add('is-visually-hidden'));
      Promise.all(currContent.getAnimations().map(animation => animation.finished)).then(() => currContent.classList.add('is-visible'));
    } else {
      currWrapper?.classList.remove('is-visually-hidden');
      currContent?.classList.remove('is-visible');
    }
  }, [pageIsLoaded]);
  return jsxs("div", {
    className: loaderContainerClass,
    children: [jsx("div", {
      className: loaderWrapperClass,
      ref: wrapperRef,
      children: jsx("span", {
        className: cssClassNames,
        title: loaderTitle,
        "aria-label": loaderTitle,
        ref: loaderRef,
        ...attributes
      })
    }), jsx("div", {
      className: loaderContentClass,
      ref: contentRef,
      children: children
    })]
  });
};
const EGDSLoaderContainer = props => {
  const l10n = useLocalization();
  return jsx(LoaderContainer, {
    l10n: l10n,
    ...props
  });
};
EGDSLoaderContainer.displayName = 'EGDSLoaderContainer';
const getClassNameList = classNames.bind(styles);
class PageLoader extends React.Component {
  static displayName = 'EGDSPageLoader';
  render() {
    const {
      props
    } = this;
    const baseCssClass = 'uitk-loader-page';
    const cssClassNames = getClassNameList(baseCssClass, props.className, {
      'is-visible': props.visible
    });
    const title = props.title || props.l10n.formatText('loading');
    if (props.visible) {
      liveAnnounce(title, Level.POLITE);
    }
    return jsx(EGDSLoader, {
      className: cssClassNames,
      title: title,
      "aria-hidden": !props.visible
    });
  }
}
const EGDSPageLoader = props => {
  const l10n = useLocalization();
  return jsx(PageLoader, {
    l10n: l10n,
    ...props
  });
};
export { EGDSLoader as E, Loader as L, PageLoader as P, EGDSPageLoader as a, EGDSLoaderContainer as b };